import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingHeadshotGeneratorConfig } from '@/data/landingConfig/landingHeadshotGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_HeadshotGenerator } from './schemaObject';

interface Props {}
const HeadshotGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_HeadshotGenerator} />
			<LandingTemplate
				data={landingHeadshotGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelHeadshotGenerator()}
			/>
		</>
	);
};

export default HeadshotGenerator;
